// extracted by mini-css-extract-plugin
module.exports = {"header":"addingSectionHeader_header__1C3No","left_sec":"addingSectionHeader_left_sec__2h9aJ"};